export type SummeryReportVmRunningStatus = "running";
export type SummeryReportVmStoppedStatus = "stopped";
export type SummeryReportVmPendingStatus = "pending";

export const SummaryReportVmStatuses: [
  SummeryReportVmRunningStatus,
  SummeryReportVmStoppedStatus,
  SummeryReportVmPendingStatus
] = ["running", "stopped", "pending"];
